/**
 * 会员经营 · 区块常量
 * ------------------------------------------------------------------
 * 锚点列表与 DOM id 的唯一来源：容器、锚点导航、section 都从这里取，
 * 避免两处手写导致「点了锚点跳不到」。
 */
export const MEMBER_ITEMS = [
  { key: 'overview', label: '会员概览' },
  { key: 'portrait', label: '会员画像' },
  { key: 'behavior', label: '会员行为' },
  { key: 'clockin', label: '会员打卡' },
  /* 看得见活动挪到最后（图4 反馈）：它是活动运营数据，
     不是会员本身的经营指标，放中间会打断「概览→画像→行为→打卡」的主线 */
  { key: 'activity', label: '看得见活动' },
];

/** 锚点 section 的 DOM id：由 key 统一生成 */
export const sidOf = (key) => `member-${key}`;

export default MEMBER_ITEMS;
